import { GridWithTemplatesProps } from 'components/GridWithTemplates/types';
import { FC, useCallback, useEffect, useState } from 'react';
import { TemplateModel } from 'templates/types';

import type { FetchedTemplateModel } from 'types/global';

import getData from 'utils/getData';
import processBackEndData from 'utils/processBackEndTemplate';

function withFetchTemplates(Component: FC<any>, itemLimit: number) {
  return function HOC(props: GridWithTemplatesProps) {
    const [data, setTemplateData] = useState<TemplateModel[]>([]);
    const [error, setError] = useState(false);
    const [loading, setLoading] = useState(true);

    const { tag, templateData } = props;

    const getTags = useCallback(async () => {
      const result: FetchedTemplateModel[] = await getData({
        tag,
        itemLimit,
      });

      if (!result && templateData) {
        setTemplateData(processBackEndData(templateData));
      } else if (!result && !templateData) {
        setError(true);
      } else {
        setTemplateData(processBackEndData(result));
        setError(false);
        setLoading(false);
      }
    }, [templateData, tag]);

    useEffect(() => {
      getTags().catch(() => setError(true));
    }, [getTags]);

    return <Component {...props} templateData={data} error={error} isLoading={loading} />;
  };
}

export default withFetchTemplates;
